import {
	coreRowsFeature,
	rowSortingFeature,
	rowPaginationFeature,
	columnFilteringFeature,
	columnVisibilityFeature,
	columnSizingFeature,
	globalFilteringFeature,

	createCoreRowModel,
	createSortedRowModel,
	createFilteredRowModel,
	createPaginatedRowModel,
} from "@tanstack/react-table";
export { createColumnHelper } from "@tanstack/react-table";

export const CommonFeatures = {
	coreRowsFeature: coreRowsFeature,
	rowPaginationFeature: rowPaginationFeature,
	rowSortingFeature: rowSortingFeature,
	columnVisibilityFeature: columnVisibilityFeature,
	columnSizingFeature: columnSizingFeature,
	columnFilteringFeature: columnFilteringFeature,
	globalFilteringFeature: globalFilteringFeature,

	coreRowModel: createCoreRowModel(),
	paginatedRowModel: createPaginatedRowModel(),
	sortedRowModel: createSortedRowModel(),

	filteredRowModel: createFilteredRowModel(),
	filterFns: {},
};
export type CommonFeatures = typeof CommonFeatures;

export const EMPTY_ARRAY: [] = [];


//Allows us to define custom properties for our columns
declare module "@tanstack/react-table" {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars -- All declarations of 'ColumnMeta' must have identical type parameters.ts(2428)
	interface ColumnMeta<TFeatures, TData, TValue> {
		filterVariant?: "text" | "range" | "select";
		filterOptions?: Array<[string, string]> | Record<string, string>; // Options for select filters
	}
}
